export const agmInitialData = [{
  "Site_Name": "",
  "Verified": "No",
  "Est_Lat": "",
  "Est_Lng": "",
  "Planning_Notes": "",
  "Real_Lat": "",
  "Real_Lng": "",
  "GPS_Taken": "No",
  "Site_Type": "Select",
  "Ref_Point": "",
  "Dist_Ref_Point": "",
  "Site_Notes": "",
  "Address": "",
  "Access_Notes": "",
  "Chain_Quality": "Select",
  "Height": "",
  "Northing": "",
  "Easting": "",
  "Elevation": "",
  "Depth": "",
  "Adj_Elevation": "",
  "H_Perc": "",
  "V_Perc": "",
  "PDOP": "",
  "Obtime": "",
  "LSD": "",
}]

export const scInitialData = [
  {
      "SC_Name": "",
      "US_Site": "",
      "DS_Site": "",
      "Dist_To_US": "",
      "Dist_To_DS": "",
      "lat": 0,
      "lng": 0,
      "Elevation": ""
    }
]